import React, { Component } from 'react'

// Styles
import './index.scss'

// Components
import Media from '../../components/Media'

// Constants
import { MARKET_TABS } from './constants'

class Market extends Component {
  render = () => {
    return (
      <div className="market-parent">
        <div className="page-banner bg-page-banner vh-center">
          <div className="banner-content">
            <h2>Market</h2>
          </div>
        </div>

        <div className="f-w content">
          <div className="container">
            <div className="flex xlg-col-flex">
              <div className="inner">
                <p>With wide-ranging expertise and experience, EIDIM offers a comprehensive audio visual service making us the AV partner of choice for many organisations. We can lead and manage large and complex audio visual projects, but also tailor effective solutions for smaller-scale requirements.</p>
              </div>

              <div className="inner">
                <p>We have worked on projects involving all types of audio visual technology; engineering purpose-built systems for a broad array of industries and facilities. We use our ingenuity to seamlessly blend audio visual, information technology (IT) and communications; and build superior systems that are efficient, reliable and cutting-edge.</p>
              </div>
            </div>
          </div>
        </div>

        <div className="f-w categories">
          <div className="flex lg-col-flex lap-flex-wrap">
            {
              MARKET_TABS.map((item, i) => {
                return (
                  <div className="width-33" key={`market-${item + i}`}>
                    <Media
                      className={item.className}
                      head={item.head}
                      link={item.link}
                    />
                  </div>
                )
              })
            }
          </div>
        </div>
      </div>
    )
  }
}

export default Market